import { Price } from "../Price";
import { makeImmutable } from "../../core/makeImmutable";
/**
 * How the modifiers can
 *
 * https://restaumatic.atlassian.net/browse/RS-5851?atlOrigin=eyJpIjoiYTZmZWNlZjM4NGNhNGRmZTlmNWEwOTQwY2I1ODdiNGMiLCJwIjoiaiJ9
 */
export class ModifierExchangePolicy {
    constructor(params) {
        this.type = params.type;
        makeImmutable(this);
    }
    price({ selectionPrice, defaultSelectionPrice, addedOnlyPrice, }) {
        switch (this.type) {
            case "NotIncluded":
                return selectionPrice;
            case "UnlimitedExchange":
                return selectionPrice.sub(defaultSelectionPrice);
            case "ExchangeWithClamp":
                return selectionPrice.sub(defaultSelectionPrice).max(Price.free());
            case "AdditionOnly":
                return addedOnlyPrice;
        }
    }
}
